
const toastBlack = {
    state: {
        show: false,
        title: ''
    },
    mutations: {
        toastBlack (state, payload) {
            state.title = payload.title;
            state.show = payload.show;
        }
    },
    actions: {
        toastBlack (context, payload) {
            if (context.state.show) {
                return;
            }
            context.commit('toastBlack', payload);
            setTimeout(function() {
                context.commit('toastBlack', {show: false, title: ''});
            }, 3000);
        }
    }
}

export default toastBlack;



// WEBPACK FOOTER //
// ./src/stores/modules/public/toastBlack.js